import { useQuery } from '@tanstack/react-query';
import { getAdminApi } from '@damar/admin-hooks';
import type { InboxItem, MyRequestItem, InboxCountResponse } from './inbox.types';

export const inboxKeys = {
  pending: ['inbox', 'pending'] as const,
  myRequests: ['inbox', 'my-requests'] as const,
  count: ['inbox', 'count'] as const,
};

export function usePendingApprovals() {
  return useQuery({
    queryKey: inboxKeys.pending,
    queryFn: async () => {
      const { data } = await getAdminApi().get<InboxItem[]>('/api/v1/workflow/inbox/pending');
      return data;
    },
  });
}

export function useMyRequests() {
  return useQuery({
    queryKey: inboxKeys.myRequests,
    queryFn: async () => {
      const { data } = await getAdminApi().get<MyRequestItem[]>('/api/v1/workflow/inbox/my-requests');
      return data;
    },
  });
}

export function useInboxCount() {
  return useQuery({
    queryKey: inboxKeys.count,
    queryFn: async () => {
      const { data } = await getAdminApi().get<InboxCountResponse>('/api/v1/workflow/inbox/count');
      return data;
    },
    refetchInterval: 30_000,
  });
}
